import React from "react";
import "./CompanyOverview.css"; // Using the same style as Company Overview

const PrivacyPolicy = () => {
    return (
        <div className="company-wrapper">
            <div className="company-card">
                <h1 className="main-heading">🔒 Privacy Policy for Global Link Corporation</h1>
                <p>
                    At Global Link Corporation, accessible from{' '}
                    <a href="https://www.globallinkcorporation.com" target="_blank" rel="noopener noreferrer">
                        https://www.globallinkcorporation.com
                    </a>, the privacy of our visitors is one of our main priorities. This Privacy Policy
                    document outlines the types of information collected and recorded by Global Link
                    Corporation and how we use it.
                </p>
                <p>
                    If you have any questions or need more information about our Privacy Policy, please contact us at{' '}
                    <a href="mailto:Info@globallinkcorporation.com">Info@globallinkcorporation.com</a>.
                </p>

                <h2>Consent</h2>
                <p>
                    By using our website, you consent to our Privacy Policy and agree to its terms.
                </p>

                <h2>Information We Collect</h2>
                <p>
                    The personal information we ask you to provide, and the reasons why we ask for it, will be made clear when we ask you to provide it.
                </p>
                <p>
                    If you contact us directly, we may receive additional information such as your name, email address, phone number, and the contents of the message or attachments you may send us.
                </p>
                <p>
                    When you register for an account or submit an inquiry, we may collect your name, company name, address, email address, phone number, and other relevant contact details.
                </p>

                <h2>How We Use Your Information</h2>
                <ul>
                    <li>Operating and maintaining our website</li>
                    <li>Improving and personalizing the user experience</li>
                    <li>Analyzing usage trends and website performance</li>
                    <li>Communicating with you regarding your inquiries or our services</li>
                    <li>Sending promotional emails (with your permission)</li>
                    <li>Detecting and preventing fraud</li>
                </ul>

                <h2>Log Files</h2>
                <p>
                    Global Link Corporation follows standard procedures for using log files. These files log visitors when they visit websites. The information collected includes:
                </p>
                <ul>
                    <li>Internet Protocol (IP) addresses</li>
                    <li>Browser type and version</li>
                    <li>Internet Service Provider (ISP)</li>
                    <li>Date and time stamp</li>
                    <li>Referring/exit pages</li>
                    <li>Number of clicks</li>
                </ul>
                <p>
                    This information is not linked to personally identifiable information and is used for site administration and trend analysis.
                </p>

                <h2>Cookies and Web Beacons</h2>
                <p>
                    Like many other websites, Global Link Corporation uses “cookies” to store visitor preferences and optimize the user experience. These cookies may store information such as browser type and pages visited.
                </p>

                <h2>Third Party Privacy Policies</h2>
                <p>
                    Our Privacy Policy does not apply to third-party advertisers or websites. We recommend that you consult their respective policies for detailed information.
                </p>
                <p>
                    You may choose to disable cookies through your browser settings. For more detailed instructions, visit your browser’s help section.
                </p>

                <h2>Data Protection Rights (GDPR & CCPA)</h2>
                <p>
                    Depending on your location, you may have the right to:
                </p>
                <ul>
                    <li>Access your personal data</li>
                    <li>Correct inaccurate data</li>
                    <li>Request deletion of your data</li>
                    <li>Restrict or object to our processing</li>
                    <li>Request data portability</li>
                    <li>Withdraw your consent at any time</li>
                </ul>
                <p>
                    To exercise any of these rights, please contact us at{' '}
                    <a href="mailto:Info@globallinkcorporation.com">Info@globallinkcorporation.com</a>. We will respond within one month.
                </p>

                <h2>Children’s Privacy</h2>
                <p>
                    Global Link Corporation does not knowingly collect personal information from children under the age of 13. If you believe your child has provided us with personal data, please contact us immediately and we will delete such information promptly.
                </p>

                <h2>Changes to This Policy</h2>
                <p>
                    We may update our Privacy Policy from time to time. Any changes will be posted on this page with an updated “Last Modified” date.
                </p>
                <p><strong>Last Modified:</strong> 27 June 2025</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
